// extracted by mini-css-extract-plugin
module.exports = {"fade-out":"fade_out_link__fade-out___11Awh"};